import React, { useState, useEffect, useRef, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';
import "../pagination/pagination.css"
import Pagination from '../pagination/pagination';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from '../../services/apiService';
import { toast } from 'react-toastify';
const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const LeaseListing = () => {
    const [rowData, setRowData] = useState([]);
    const [proprtyList, setProperty] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const apiService = new LeaseApiService();
    const gridRef = useRef();
    const [FilterTab, setFilterTab] = useState(true);
    const [permissions, setPermissions] = useState([]);
    let navigate = useNavigate();
    const [contextMenu, setContextMenu] = useState(null);
    const StatusFilter = [
        { value: 'All', label: 'All' },
        { value: '0', label: 'Active' },
        { value: '1', label: 'lease Reserved' },
    ];

    useEffect(() => {
        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);
        return () => window.removeEventListener('click', handleClickOutside);
    }, []);
    const [formData, setFormData] = useState({
        email: "",
        Proprty: [{ label: 'Select Property', value: '' }],
        Status: [{ label: 'All', value: '' }],
        Unit: [{ label: 'Select Unit', value: '' }],
        LeaseNo: [{ label: 'Select Lease No', value: '' }],
    });

    useEffect(() => {
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Lease Agreement");
        setPermissions(permissions[0]);
    }, []);
    useEffect(() => {
        getItems();
    }, []);
    useEffect(() => {
        fetchDropdownData();
    }, []);
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LASerPropertyName');
            const res = await apiService.getApiParamater('GET_PROPERT_DROP', `?${params.toString()}`);
            setProperty([{ value: 'All', text: 'All' }, ...res?.data?.dropdowns?.LASerPropertyName]);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handleEdit = async (rowData) => {
        const params = new URLSearchParams();
        params.append('Action', 'checkLeaseEditValidation');
        // params.append('GroupId', rowData?.groupId);
        params.append('LeaseNo', rowData?.leaseNo);
        const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
        let data = res?.data?.result?.data
        if (data?.Invoices >= 0 && data?.Receipts === 0) {
            navigate(`/Lease/Management/LeaseAgreement/Create`, { state: rowData });
        } else if (data?.Invoices > 0 || data?.Receipts > 0) {
            toast.warning("Invoices or Receipts created, lease Agreement Cannot be edited")
        }
    }
    const handleAdd = async (rowData) => {
        navigate(`/Lease/Management/LeaseAgreement/Create`, { state: rowData });
    }
    const handlePrint = (rowData) => {
        if (rowData) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase");
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }

            // Open both reports simultaneously
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup";
                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "RecordId", value: "" },
                    { name: "LeaseNo", value: rowData?.leaseNo },
                    { name: "ReceiptNo", value: "" },
                    { name: "reportName", value: "LSEREG" },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });
                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    const openReportPopup = (rowData) => {
        if (rowData) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase");
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }

            // Open both reports simultaneously
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup2",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup2";
                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "RecordId", value: "" },
                    { name: "LeaseNo", value: rowData?.leaseNo },
                    { name: "ReceiptNo", value: "" },
                    { name: "reportName", value: "LSEAGMNT" },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    const openStatementPopup = (rowData) => {
        if (rowData) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase");
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }

            // Open both reports simultaneously
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup3",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup3";
                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "RecordId", value: "" },
                    { name: "LeaseNo", value: rowData?.leaseNo },
                    { name: "ReceiptNo", value: "" },
                    { name: "reportName", value: "LSESTMT" },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage || 1, filters = formData) => {
        try {
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', pageSize || 20);
            params.append('PropertyName', filters?.Proprty?.label || 'All');
            params.append('UnitNo', filters?.Unit?.value ? filters.Unit.label : 'All');
            params.append('Status', filters?.Status?.label || 'All');
            const res = await apiService.getApiParamater('GET_LEASE_AGRE', `?${params.toString()}`);
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            // Handle error (e.g., show error message to user)
            setLoading(false); // Set loading to false even in case of error
        }
    }
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    };
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    };
    const handleMenuAction = (action, rowData) => {
        if (action === 'add') {
            handleAdd(rowData);
        } else if (action === 'edit') {
            handleEdit(rowData);
        } else if (action === 'statement') {
            openStatementPopup(rowData);
        } else if (action === 'reserv') {
            handlePrint(rowData);
        } else if (action === 'aggrement') {
            openReportPopup(rowData);
        } else if (action === 'Print') {
            handlePrintReservation(rowData)
        }
        setContextMenu(null); // Close the menu
    };
    const columnDefs = [
        {
            headerName: '', field: 'recordId', cellRenderer: BtnCellRenderer, pinned: 'left',
            cellRendererParams: {
                clicked: function (field, exp2) {
                    handleMenuAction(field, exp2);
                },
            }, width: 30,
        },

        { headerName: 'Status', field: 'status', filter: true, floatingFilter: true, suppressMovable: true, width: 150, pinned: 'left' },
        {
            headerName: 'Lease No', field: 'leaseNo', filter: true, floatingFilter: true, suppressMovable: true, width: 150
        }, {
            headerName: "Period From", field: "leaseStart", filter: true, floatingFilter: true,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },
        {
            headerName: "Period To", field: "leaseEnd", filter: true, floatingFilter: true,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },
        { headerName: 'Property', field: 'propertyName', filter: true, floatingFilter: true, suppressMovable: true, width: 250 },
        { headerName: 'Unit Num', field: 'unitNo', filter: true, floatingFilter: true, suppressMovable: true, width: 100 },
        { headerName: 'Unit Type', field: 'unitType', filter: true, floatingFilter: true, suppressMovable: true, width: 100 },
        { headerName: 'Account Code', field: 'tenantNo', filter: true, floatingFilter: true, suppressMovable: true, width: 250 },
        { headerName: 'Tenant', field: 'tenantName', filter: true, floatingFilter: true, suppressMovable: true, width: 250 },
        { headerName: 'Contact Num', field: 'contactNo', filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: 'Year Rent', field: 'yearRent', filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: 'Discount', field: 'discount', filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: 'Contract Value', field: 'total', filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: 'Rent', field: 'rent', filter: true, floatingFilter: true, suppressMovable: true, width: 100 },
        { headerName: 'VAT', field: 'vat', filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: 'Total', field: 'total', filter: true, floatingFilter: true, suppressMovable: true, width: 100 },
        { headerName: 'Tax', field: 'tax', filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: 'BedRooms', field: 'tax1', filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: 'Area', field: 'totalArea', filter: true, floatingFilter: true, suppressMovable: true, width: 100 },
        { headerName: 'Installments', field: 'installments', filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        { headerName: 'Remarks', field: 'remarks', filter: true, floatingFilter: true, suppressMovable: true, width: 180 },
        { headerName: 'Modified', field: 'modifiedBy', filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        {
            headerName: "Modified On", field: "modifiedOn", filter: true, floatingFilter: true,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },
        { headerName: 'Created By', field: 'createdBy', filter: true, floatingFilter: true, suppressMovable: true, width: 140 },
        {
            headerName: "Created on", field: "createdOn", filter: true, floatingFilter: true,
            valueFormatter: dateFormatter,
            comparator: dateComparator, suppressMovable: true, width: 136
        },

    ];
    const handleClearFilters = () => {
        const clearedFilters = {
            Proprty: [{ label: 'Select Property', value: '' }],
            Unit: [{ label: 'Select Unit', value: '' }],
            LeaseNo: [{ label: 'Select Lease No', value: '' }],
            Status: [{ label: 'All', value: '' }],
        };
        setFormData(clearedFilters);
        setUnitList([]);
        setRowData([]);
        gridRef.current?.api?.setFilterModel(null);
        setLoading(true);
        getItems(1, clearedFilters);
    };
    const handlePropertyChange = async (selectedOption) => {
        setFormData({ ...formData, Proprty: selectedOption, Unit: [{ label: 'Select Unit', value: '' }] });
        const params = new URLSearchParams();
        params.append('DropdownFor', 'LRUnitNosByPropertyId');
        params.append('CascadValue', selectedOption?.value);
        const res = await apiService.getApiParamater('REPORT_CASCAD', `?${params.toString()}`);
        setUnitList(res?.data?.items || []);

    }
    const handleStatusFilter = (selectedOption) => {
        if (selectedOption.label == "All") {
            handleClearFilters()
        } else {
            setFormData({ ...formData, Status: selectedOption });
        }
    }
    const handleUnitNoFilter = (selectedOption) => {
        setFormData({ ...formData, Unit: selectedOption });
    }

    const handlePrintReservation = (rowData) => {
        if (rowData) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase");
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }

            // Open both reports simultaneously
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup";
                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "RecordId", value: "" },
                    { name: "LeaseNo", value: rowData?.leaseNo },
                    { name: "ReceiptNo", value: "" },
                    { name: "reportName", value: "LSERESV1" },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });
                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }

            // openReportPopup({ rowData, reportName: 'LSERESV1', popupName: `ReportPopup1_${Date.now()}` });
            // openReportPopup({ rowData, reportName: 'LSERESV2', popupName: `ReportPopup2_${Date.now() + 1}` });
        }
    }
    return (
        <div className="p-3">
            <div className="cost-center-section">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}>
                    <div className='param-label pt-1'>Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                        <div className='row'>
                            <div className='col'>
                                <Select
                                    className="p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={formData.Proprty}
                                    onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                    options={proprtyList?.map((rec) => ({ value: rec?.value, label: rec?.text }))}
                                />
                            </div>
                            <div className='col'>
                                <Select
                                    className="p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={formData.Unit}
                                    options={unitList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map((rec) => ({ value: rec?.value, label: rec?.text }))}
                                    onChange={handleUnitNoFilter}
                                />
                            </div>
                            <div className='col'>
                                <Select
                                    className="p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={formData.Status}
                                    options={StatusFilter}
                                    onChange={handleStatusFilter}
                                />
                            </div>
                            <div className='col-3 d-flex gap-2'>
                                <div
                                    onClick={() => getItems(1)}
                                    className='mainbtnGry flex-end gap-2 w-50'>
                                    <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Search</div>
                                </div>
                                <div
                                    onClick={() => handleClearFilters()}
                                    className='mainbtnRed flex-end gap-2 w-50'>
                                    <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='border-box2 p-3'>
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className='d-flex justify-contant-between '>
                            <h5 className='col mainInvHead'>Lease Agreement List</h5>
                        </div>
                        <div className='gridshad  mt-2'>
                            <div className="ag-theme-quartz" style={{ height: 650 }}>
                                <AgGridReact
                                    ref={gridRef}
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: '#F0EDF5' };
                                        } else {
                                            return { background: '#fff' };
                                        }
                                    }}
                                    rowData={rowData}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                    frameworkComponents={{ BtnCellRenderer }}
                                    context={{ setContextMenu }}
                                />
                            </div>
                            <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
                        </div>
                    </>
                )}
            </div>

            {contextMenu && (
                <div
                    style={{
                        position: 'absolute',
                        top: contextMenu.mouseY,
                        left: contextMenu.mouseX,
                        backgroundColor: 'white',
                        border: '1px solid gray',
                        zIndex: 1000,
                        padding: '10px 30px',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 6px rgba(0,0,0,0.2)'
                    }}
                >
                    {contextMenu.data?.status === "Active" ?
                        <div className='' style={{ display: "grid" }}>
                            {/* <button className="btn btn-secondary " onClick={() => handleMenuAction('edit', contextMenu.data)}>
                                Edit Lease Agreement
                            </button> */}
                            <button className="btn btn-secondary my-1" onClick={() => handleMenuAction('statement', contextMenu.data)}>
                                Lease Statement
                            </button>
                            <button className="btn btn-secondary mt-1 " onClick={() => handleMenuAction('reserv', contextMenu.data)}>
                                Lease  Tenant Registration
                            </button>
                            <button className="btn btn-secondary mt-1" onClick={() => handleMenuAction('aggrement', contextMenu.data)}>
                                Lease Agreement
                            </button>
                            <button className="btn btn-secondary mt-1 " onClick={() => handleMenuAction('Print', contextMenu.data)}>
                                Print Reservation
                            </button>
                        </div >
                        :
                        <div className='' style={{ display: "grid" }}>
                            {permissions?.canAdd === true ?
                                <button className="btn btn-secondary " onClick={() => handleMenuAction('add', contextMenu.data)}>
                                    Create Lease Agreement
                                </button> : ""}
                            <button className="btn btn-secondary mt-1 " onClick={() => handleMenuAction('Print', contextMenu.data)}>
                                Print Reservation
                            </button>
                            <button className="btn btn-secondary mt-1 " onClick={() => handleMenuAction('reserv', contextMenu.data)}>
                                Lease  Tenant Registration
                            </button>
                        </div>
                    }

                </div>
            )}
        </div>

    );
};

class BtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.stopPropagation(); // Prevent row selection
        const { context, data } = this.props;

        if (context && context.setContextMenu) {
            context.setContextMenu({
                mouseX: e.clientX,
                mouseY: e.clientY,
                data: data
            });
        }
    }

    render() {
        return (
            <div className='center pt-1'>
                <span onClick={this.handleClick} style={{ cursor: 'pointer', fontSize: '30px' }}>
                    &#8942; {/* Vertical Ellipsis */}
                </span>
            </div>
        );
    }
}
export default LeaseListing;
